import type {
  ICancellationOptions,
  IMultiFieldSearchQuery,
  ISuccessApiResponse,
} from '@wyz/types';
import { serialize } from '@wyz/utils';
import { useApi } from '~/common/context';

type Result<DataItem> = {
  search: (
    queryParams: IMultiFieldSearchQuery,
    options: ICancellationOptions,
  ) => Promise<ISuccessApiResponse<DataItem[], unknown>>;
};

export const useAutocompleteSearch = <DataItem>({
  pathName,
}: {
  pathName: string;
}): Result<DataItem> => {
  const { callCoreApi } = useApi();

  const query = (
    queryParams: IMultiFieldSearchQuery,
    options: ICancellationOptions,
  ) => {
    return callCoreApi<ISuccessApiResponse<Array<DataItem>>>(
      `${pathName}?${serialize(queryParams)}`,
      options,
    );
  };

  return {
    search: query,
  };
};
